import script from "./SectionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionsTable.vue?vue&type=script&setup=true&lang=js"

import "./SectionsTable.vue?vue&type=style&index=0&id=7f7d8776&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7d8776"]])

export default __exports__